<template>
    <div class="my-wrap">
        <div class="notice-wrap">
            <div class="notice-left-wrap">
                <div class="iconfont">&#xe6bf;</div>
                <div class="notice-content-wrap regular">
                    {{ $t("my.tip") }}
                </div>
            </div>
        </div>
        <div class="table-wrap">
            <!-- 今日预约 -->
            <el-table v-if="tableType == 0" :data="lastMakeList" style="width: 100%" stripe :empty-text="$t('my.empty')"
                cell-class-name="cellName" header-cell-class-name="headerCellName">
                <el-table-column :label="$t('my.table1.seat')" width="400" align="left" header-align="center">
                    <template slot-scope="scope">
                        <div class="order-info-wrap">
                            <div class="order-room-name regular">
                                {{ scope.row.location + '|' + scope.row.seatLabel + '座位' }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('my.table1.date')" width="120" align="center" header-align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.makeDateStr != ''">{{ scope.row.makeDateStr
                            }}</span>
                        <span v-else>-- --</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('my.table1.time')" width="150" align="center" header-align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.actualStr != '' ? scope.row.actualStr.replace("_", '~') :
                        scope.row.makeBeginStr
                        + '~' +
                        scope.row.makeEndStr }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('my.table1.leaveTime')" width="150" align="center" header-align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.awayRange ? scope.row.awayRange : '~~' }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('my.table1.code')" align="center" header-align="center" min-width="130">
                    <template slot-scope="scope">
                        <span>{{ scope.row.receipt }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('my.table1.status')" align="center" header-align="center" min-width="80">
                    <template slot-scope="scope">
                        <span>
                            <template class="status" v-if="scope.row.status == 'CHECK_IN'">{{ $t('my.table1.status1')
                                }}</template>
                            <template class="status" v-if="scope.row.status == 'LEAVE_EARLY'">{{ $t('my.table1.status2')
                                }}</template>
                            <template class="status" v-if="scope.row.status == 'AWAY'">{{ $t('my.table1.status3')
                                }}</template>
                            <template class="status" v-if="scope.row.status == 'RESERVE'">{{ $t('my.table1.status4')
                                }}</template>
                            <template class="status" v-if="scope.row.status == 'STOP'">{{ $t('my.table1.status5')
                                }}</template>
                            <template class="status" v-if="scope.row.status == 'MISS'">{{ $t('my.table1.status6')
                                }}</template>
                            <template class="status" v-if="scope.row.status == 'CANCEL'">{{ $t('my.table1.status7')
                                }}</template>
                            <template class="status" v-if="scope.row.status == 'NO_STOP'">{{ $t('my.table1.status8')
                                }}</template>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('my.table1.op')" align="center" header-align="center" min-width="200">
                    <template slot-scope="scope">
                        <div class="buttons-wrap">
                            <!-- 取消预约 -->
                            <span class="btn-span canncel" v-if="scope.row.status == 'RESERVE'"
                                @click="cancelBook(scope.row, scope.$index)">{{
                        $t("my.table1.op3") }}
                            </span>
                            <!-- 查看变更记录 -->
                            <span class="btn-span canncel" v-if="scope.row.status == 'CHECK_IN'"
                                @click="_stop(scope.$index)">{{
                        $t("my.table1.op1") }}</span>
                            <span class="btn-span pro" @click="getRecords(scope.row.id)">{{
                        $t("my.table1.op2") }}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 预约记录 -->
            <el-table v-if="tableType == 1" :data="orderList" style="width: 100%" stripe :empty-text="$t('my.empty')"
                cell-class-name="cellName" header-cell-class-name="headerCellName">
                <el-table-column :label="$t('my.table1.seat')" width="400" align="left" header-align="center">
                    <template slot-scope="scope">
                        <div class="order-info-wrap">
                            <div class="order-room-name regular">
                                {{ scope.row.location + '|' + scope.row.seatLabel + '座位' }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('my.table1.date')" width="120" align="center" header-align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.makeDateStr != ''">{{ scope.row.makeDateStr
                            }}</span>
                        <span v-else>-- --</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('my.table1.time')" width="150" align="center" header-align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.actualStr != '' ? scope.row.actualStr.replace("_", '~') :
                        scope.row.makeBeginStr
                        + '~' +
                        scope.row.makeEndStr }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('my.table1.leaveTime')" width="150" align="center" header-align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.awayRange ? scope.row.awayRange : '~~' }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('my.table1.code')" align="center" header-align="center" min-width="130">
                    <template slot-scope="scope">
                        <span>{{ scope.row.receipt }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('my.table1.status')" align="center" header-align="center">
                    <template slot-scope="scope">
                        <span>
                            <template class="status" v-if="scope.row.status == 'CHECK_IN'">{{ $t('my.table1.status1')
                                }}</template>
                            <template class="status" v-if="scope.row.status == 'LEAVE_EARLY'">{{ $t('my.table1.status2')
                                }}</template>
                            <template class="status" v-if="scope.row.status == 'AWAY'">{{ $t('my.table1.status3')
                                }}</template>
                            <template class="status" v-if="scope.row.status == 'RESERVE'">{{ $t('my.table1.status4')
                                }}</template>
                            <template class="status" v-if="scope.row.status == 'STOP'">{{ $t('my.table1.status5')
                                }}</template>
                            <template class="status" v-if="scope.row.status == 'MISS'">{{ $t('my.table1.status6')
                                }}</template>
                            <template class="status" v-if="scope.row.status == 'CANCEL'">{{ $t('my.table1.status7')
                                }}</template>
                            <template class="status" v-if="scope.row.status == 'NO_STOP'">{{ $t('my.table1.status8')
                                }}</template>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('my.table1.op')" align="center" header-align="center" min-width="200">
                    <template slot-scope="scope">
                        <div class="buttons-wrap">
                            <!-- 查看变更记录 -->
                            <span class="btn-span pro" @click="getRecords(scope.row.id)">{{
                        $t("my.table1.op2") }}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 违约记录 -->
            <el-table v-if="tableType == 2" :data="validateList" style="width: 100%" stripe :empty-text="$t('my.empty')"
                cell-class-name="cellName" header-cell-class-name="headerCellName">

                <el-table-column :label="$t('my.table1.seat')" width="340" align="left" header-align="center">
                    <template slot-scope="scope">
                        <div class="order-info-wrap">
                            <div class="order-room-name regular">
                                {{ scope.row.location + '|' + scope.row.seatLabel + '座位' }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('my.table1.date')" width="140" align="center" header-align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.makeDateStr != ''">{{ scope.row.makeDateStr
                            }}</span>
                        <span v-else>-- --</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('my.table1.time')" width="230" align="center" header-align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.actualStr != '' ? scope.row.actualStr.replace("_", '~') :
                        scope.row.makeBeginStr
                        + '~' +
                        scope.row.makeEndStr }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('my.table1.leaveTime')" width="200" align="center" header-align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.awayRange ? scope.row.awayRange : '~~' }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('my.table1.validateTime')" width="140" align="left" header-align="center">
                    <template slot-scope="scope">
                        <div class="order-info-wrap">
                            <div class="order-room-name regular">
                                {{ scope.row.makeDateStr }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('my.table1.validateReason')" align="left" header-align="center">
                    <template slot-scope="scope">
                        <div class="order-info-wrap">
                            <div class="order-room-name regular">
                                <template v-if="scope.row.status == 'MISS'">{{ $t('my.table1.status6')
                                    }}</template>
                                <template v-if="scope.row.status == 'LEAVE_EARLY'">{{ $t('my.table1.status2')
                                    }}</template>
                                <template v-if="scope.row.status == 'NO_STOP'">{{ $t('my.table1.status8')
                                    }}</template>
                                    <div class="isExpire" v-if="scope.row.isExpire">{{ $t('my.table1.loseEfficacy')}}</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div v-if="tableType == 3 && Boolean(vueConfig.doorLog)" style="text-align: start;">
              <el-date-picker class="timeSelect" v-model="timeSelect" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" :clearable="false" @change="handlerDateChange"></el-date-picker>
              <el-table :data="accessList" style="width: 100%;" height="600px" stripe :empty-text="$t('my.empty')"
                cell-class-name="cellName" header-cell-class-name="headerCellName">
                <el-table-column :label="$t('my.table_access_control.op1')" prop="doorName" align="center" header-align="center"></el-table-column>
                <el-table-column :label="$t('my.table_access_control.op2')" prop="dateTimeStr" align="center" header-align="center"></el-table-column>
                <el-table-column :label="$t('my.table_access_control.op3')" prop="directionStr" align="center" header-align="center"></el-table-column>
              </el-table>
            </div>
        </div>
        <div class="pagination-wrap" v-if="tableType != 3">
            <div class="total-wrap regular">{{ total }} {{ $t("my.totalWord") }}</div>
            <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="currentPage"
                :page-size="pageSize" @current-change="handleCurrentChange" v-if="tableType != 0">
            </el-pagination>
        </div>

        <!-- 变更记录 -->
        <el-dialog :title="$t('my.table1.op2')" custom-class="add-dialog-wrap" :visible.sync="showRecords"
            :close-on-click-modal="false" :show-close="true" width="400px" round>
            <el-steps direction="vertical" :active="makeList.length">
                <el-step :title="item.stageName" v-for="(item, index) in makeList" :key="index">
                    <template slot="description">
                        <div class="title">操作时间： {{ item.createdDate }}</div>
                        <div class="des" style="margin-bottom: 30px;">读者在{{ item.sourceName }}进行{{ item.stageName }}</div>
                    </template>
                </el-step>
            </el-steps>
        </el-dialog>
    </div>
</template>

<script>
import tipPopUps from "@/components/tipPopUps";
import {
    getUserLastResveration, getUserDefault, getUserHistory, getMakeLifeList, cancelOrder, continuedSeatTime, extendMake, stopSeat, fetchUserDoorLog
} from "@/api/index";

import utils from '@/lib/utils'
export default {
    components: {
        "tip-popups": tipPopUps,
    },
    data() {
        return {
            reservation: {},
            tableType: 0,
            total: 0,
            pageSize: 10,
            currentPage: 0,
            lastMakeList: [],
            orderList: [],
            validateList: [],
            makeList: [],
            showRecords: false,
            extendsTime: [],
            showExtend: false,
            isRenewF: false,
            isRenewT: false,
            isRenew: false,
            extendsStr: '',
            orderObj: {},
            // 门禁数据
            accessList: [], // 门禁数据
            allAccessList: [], // 门禁数据
            timeSelect: new Date().toJSON().substring(0, 10),
            vueConfig: JSON.parse(sessionStorageProxy.getItem('vueConfig'))
        };
    },
    methods: {
        handlerDateChange (val) {
          this.timeSelect = val
          this.getUserDoorLog()
        },
        closeRenew: function () {

        },
        renewTimeEvent: function () {
        },
        handleCurrentChange: function (e) {

            if (this.tableType == 1) {
                this.getResverationFun(this.pageSize, e)
            } else {
                this.getValidateRecords(this.pageSize, e)
            }
        },
        //获取记录的方法，父路由调用
        getDataList: function (type) {
            this.tableType = type
            this.total = 0
            this.pageSize = 10
            this.currentPage = 0
            if (type == 0) {
                this.lastMakeList = []
                this.getLastMake()
            } else if (type == 1) {
                this.orderList = []
                this.getResverationFun()
            } else if (type == 2)  {
                this.validateList = []
                this.getValidateRecords()
            } else if (type == 3)  {
                this.accessList = []
                this.getUserDoorLog()
            }
        },
        //获取最近预约
        getLastMake: function () {
            getUserLastResveration().then(res => {
                if (res.data.status) {
                    this.lastMakeList = res.data.data
                    this.total = res.data.data.length
                }
            })
        },
        //获取预约记录
        getResverationFun: function (pageSize = this.pageSize, currentPage = this.currentPage++) {
            getUserHistory(currentPage, pageSize).then(res => {
                if (res.data.status) {
                    let list = res.data.data.list ? res.data.data.list : []
                    this.orderList = list
                    this.total = res.data.data.count
                }
            })
        },
        //获取违约记录
        getValidateRecords: function (pageSize = this.pageSize, currentPage = this.currentPage++) {
            let param = { page: currentPage, pageSize: pageSize }
            const { cycleTimeName } = JSON.parse(sessionStorageProxy.getItem("userInfo"))
            const { cycleDay } = JSON.parse(sessionStorageProxy.getItem('systemInfo'));
            getUserDefault(param).then(res => {
                if (res.data.status) {
                    let list = res.data.data.list ? res.data.data.list : []
                    list = list.map(item => {
                      const isExpire = new Date(`${item.makeDateStr} ${item.makeEndStr}`).getTime() < new Date(cycleTimeName) - cycleDay * 86400000
                      return {...item, isExpire}
                    })
                    this.validateList = list
                    this.total = res.data.data.count
                }
            })
        },
        //取消预约
        cancelBook: function (item, index) {
            this.$confirm(this.$t('my.table1.op3Message'), this.$t('common.tip'), {
                cancelButtonText: this.$t("common.cancel"),
                confirmButtonText: this.$t("common.yes"),
            }).then((res) => {
                cancelOrder(item.id).then(res => {
                    if (res.data.status) {
                        debugger
                        let message = this.$t('my.table1.op3MessageSuccess').replace('【N】',res.data.data)
                        this.$success(message)
                        this.getLastMake()
                    } else {
                        this.$warning(res.data.message);
                    }
                }).catch(err => {
                    console.error(`取消预约Error:${err}`);
                    this.$error("服务异常，请联系管理员")
                });
            });
        },
        // 停止使用
        _stop(index) {
            this.$confirm(this.$t('my.table1.op1Message'), this.$t('common.tip'), {
                cancelButtonText: this.$t("common.cancel"),
                confirmButtonText: this.$t("common.yes"),
                type: 'warning',
                customClass: 'confirmModals'
            }).then(() => {
                stopSeat().then(res => {
                    if (res.data.status) {
                        this.$success('结束使用成功');
                        this.getLastMake()
                    } else {
                        this.$warning(res.data.message);
                    }
                })
            }).catch(() => { });
        },
        //获取变更记录
        getRecords: function (makeId) {
            getMakeLifeList(makeId).then((res) => {
                if (res.data.status) {
                    this.makeList = res.data.data
                    this.makeList.reverse()
                    this.showRecords = true
                } else {
                    this.$warning('变更记录获取失败!');
                }
            })
        },
            // 门禁记录信息
    async getUserDoorLog () {
      const res = await fetchUserDoorLog(this.timeSelect)
        if (res.data.code == 200) {
          this.accessList = res.data.data.map(item => ({ ...item, directionStr: item.direction == 0 ? '入馆' : '离馆'}))
          this.allAccessList = res.data.data
        }
    
    },
    },
    watch: {

    },
    created() { },
    mounted() { },
};
</script>

<style lang="less" scoped>
.my-wrap {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;

    .notice-wrap {
        width: 100%;
        height: 68px;
        background: #ffffff;
        border-radius: 5px 5px 5px 5px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .notice-left-wrap {
            height: 100%;
            display: flex;
            align-items: center;
            min-width: 440px;

            .iconfont {
                color: #409eff;
                font-size: 30px;
                margin: 28px;
            }

            .notice-content-wrap {
                font-size: 19px;
                font-weight: 400;
                color: #8a8ea6;
                transform: translate(-13px, 0px);
            }
        }

        .mid-line {
            width: 3px;
            height: 20px;
            opacity: 1;
            background: #409eff;
            border-radius: 5px;
            margin-left: 30px;
        }

        .notice-right-wrap {
            padding-left: 20px;
            display: flex;
            align-items: center;

            .notice-item-wrap {
                margin-left: 40px;
                display: flex;
                align-items: center;

                .notice-color-wrap {
                    width: 17px;
                    height: 4px;
                    border-radius: 8px 8px 8px 8px;
                    transform: translate(0px, 1px);
                }

                .word-wrap {
                    margin-left: 12px;
                }
            }
        }
    }

    .table-wrap {
        padding: 25px;
        padding-bottom: 0px;
        background: white;
        flex: 1;
        margin-top: 10px;
    }

    .pagination-wrap {
        padding: 0px 25px 25px;
        background: white;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .total-wrap {
            font-size: 19px;
            font-weight: normal;
            color: rgba(0, 0, 0, 0.6);
            margin-left: 10px;
        }
    }

    .order-time-wrap {
        display: flex;
        align-items: center;
        justify-content: center;

        .order-time-star-end {
            margin-left: 15px;
            color: #666;
        }
    }

    .order-info-wrap {
        display: flex;
        align-items: center;
        justify-content: center;

        .order-room-name {
            font-size: 16px;
            text-align: center;
            .isExpire {
              color: #c1c6d6;
            }
        }

        .order-desc {
            font-size: 15px;
            margin-top: 4px;
        }
    }

    .denger {
        color: red;
        // &::before {
        //   content: "";
        //   color: red;
        //   background-color: red;
        //   width: 10px;
        //   height: 10px;
        //   border-radius: 50%;
        //   display: block;
        //   top: 45%;
        //   position: absolute;
        //   left: 30%;
        // }
    }

    .success {
        color: green;
        // &::before {
        //   content: "";
        //   color: green;
        //   background-color: green;
        //   width: 10px;
        //   height: 10px;
        //   border-radius: 50%;
        //   display: block;
        //   top: 45%;
        //   position: absolute;
        //   left: 27%;
        // }
    }

    .normal {
        color: blue;
        // &::before {
        //   content: "";
        //   color: blue;
        //   background-color: blue;
        //   width: 10px;
        //   height: 10px;
        //   border-radius: 50%;
        //   display: block;
        //   top: 45%;
        //   position: absolute;
        //   left: 22%;
        // }
    }

    .removeUser {
        background-color: #f56c6c;
        padding: 5px;
        padding-left: 10px;
        padding-right: 10px;
        color: white !important;
        border-radius: 5px;
        font-size: 14px;
        width: 50%;
        margin: 0 auto;
    }

    .buttons-wrap {
        display: flex;
        align-items: center;
        justify-content: center;

        .btn-span {
            font-size: 16px;
            font-family: "SCRegular";
            font-weight: 400;
            border: 1px solid #ccc;
            padding: 2px;
            padding-left: 4px;
            padding-right: 4px;
            cursor: pointer;
            margin: 0px 8px;
            border-radius: 2px;
            font-size: 14px;

            &.canncel {
                color: red;
            }

            &.pro {
                color: #0f6ef2;
            }
        }
    }

    .no-check {
        color: rgb(226, 42, 44);
    }

    .checked {
        color: rgb(73, 216, 140);
    }

    .btn-span:hover {
        text-decoration: underline;
    }

    //签到弹窗css ,与续约弹窗
    .sign-tip-box {
        .body-wrap {
            margin: 0px 30px;
            height: 100%;
            position: relative;
            // text-align: center;

            //竖向flex ,为了让最后一行占满整个剩余空间
            display: flex;
            flex-direction: column;

            >* {
                margin-bottom: 10px;
            }

            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 20px;
            line-height: 28px;

            div {
                .icon1 {
                    color: #7d71ff;
                }

                .icon2 {
                    color: #fdbb4b;
                }

                .icon3 {
                    color: #63daab;
                }
            }

            .failSigTips {
                text-align: center;
                margin: 10px 0 10px 0;
            }

            .el-icon-caret-right {
                margin-right: 10px;
            }

            .renew-body {
                // 只属于续约弹窗css
                flex: 1; //让最后一行占满整个剩余空间

                .title {
                    margin-bottom: 10px;
                    font-family: "PingFang SC";
                    font-style: normal;
                    font-weight: 700;
                    font-size: 18px;
                    line-height: 25px;
                    letter-spacing: -0.02em;
                    color: #15192c;
                }

                .times-list {
                    //为子元素设置
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    height: 200px;
                    overflow-y: scroll;

                    // overflow: hidden;
                    /* 设置滚动条的样式 */
                    // &::-webkit-scrollbar {
                    //   width:12px;
                    // }
                    /* 滚动槽 */
                    &::-webkit-scrollbar-track {
                        border-radius: 1px;
                    }

                    /* 滚动条滑块 */
                    &::-webkit-scrollbar-thumb {
                        border-radius: 10px;
                        background: rgba(0, 0, 0, 0.1);
                    }

                    .time-item {
                        //为子元素设置
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        align-items: center;
                        cursor: pointer;
                        //为当前元素设置
                        width: 30%;
                        height: 44px;
                        background: #f5f5f5;
                        border-radius: 5px;
                        margin-bottom: 20px;

                        font-family: "Segoe UI";
                        font-style: normal;
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 21px;
                        color: #999999;

                        //保证display: flex; flex-wrap: wrap; justify-content: space-between;时
                        //最后一行左对齐
                        /* 如果最后一行是2个元素 */
                        &:last-child:nth-child(3n - 1) {
                            // background: red;
                            margin-right: calc(30% + (10% / 2) * 1);
                        }

                        /* 如果最后一行是1个元素 */
                        &:last-child:nth-child(3n - 2) {
                            // background: blue;
                            margin-right: calc(60% + (10% / 2) * 2);
                        }
                    }
                }
            }
        }

        .timeevent {
            color: white;
            background-color: #4487f0;
            width: 100%;
            height: 100%;
            border-radius: 5px;
            text-align: center;
            // border: 1px solid black;
            line-height: 44px;
        }
    }
}
.timeSelect {
  margin-bottom: 10px;
}
</style>
<style lang="less">
.my-wrap {
    .user-list-dialog {
        .el-dialog__title {
            display: flex;
        }

        .el-dialog__title::before {
            content: "";
            width: 4px;
            height: 20px;
            background: #409eff;
            border-radius: 0px 2px 2px 0px;
            display: block;
            margin-right: 10px;
            transform: translateY(2px);
        }
    }

    .el-table td.el-table__cell,
    .el-table th.el-table__cell.is-leaf {
        font-size: 16px;
        font-family: "SCRegular";
        color: #333;
    }

    .headerCellName {
        height: 64px;
        background: #ebecf2 !important;
    }

    .order-other-user-list {
        color: #409eff;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .order-other-user-list:hover {
        text-decoration: underline;
    }

    .el-table td.el-table__cell,
    .el-table th.el-table__cell.is-leaf {
        border: none;
    }

    .el-table tr {
        height: 64px;
    }

    .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
        background: #f7f8fa;
    }

    .add-dialog-wrap {
        font-family: "SCRegular";

        .el-dialog__header {
            background: #f9f9f9;
            padding: 20px;
        }

        .add-user-wrap {
            padding: 0px 30px 10px 10px;
        }

        .add-user-title-wrap {
            font-size: 18px;
            line-height: 28px;
            color: #454859;
            display: flex;
            align-items: center;
        }

        .add-user-title-wrap::before {
            content: "*";
            display: block;
            color: #409eff;
            margin-right: 10px;
            transform: translate(0px, 2px);
        }

        .add-user-content-wrap {
            margin-top: 20px;
        }

        .add-user-btn-wrap {
            margin-top: 40px;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            .btn-wrap {
                width: 117px;
                height: 43px;
                cursor: pointer;
                border-radius: 3px 3px 3px 3px;
                font-size: 16px;
                letter-spacing: 1px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 400;
            }

            .cancel {
                background: #f0f0f0;
                color: black;
            }

            .confirm {
                margin-left: 20px;
                background: #409eff;
                color: rgba(255, 255, 255, 0.9);
            }
        }
    }

    .cancel-dialog-wrap {
        .el-dialog__header {
            background: #f9f9f9;
            padding: 20px;
        }

        .cancel-order-wrap {
            font-family: "SCRegular";
        }

        .cancel-order-title-wrap {
            font-size: 18px;
            line-height: 28px;
            color: #454859;
        }

        .cancel-order-btn-wrap {
            margin-top: 40px;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            .btn-wrap {
                width: 117px;
                height: 43px;
                cursor: pointer;
                border-radius: 3px 3px 3px 3px;
                font-size: 16px;
                letter-spacing: 1px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 400;
            }

            .cancel {
                background: #f0f0f0;
                color: black;
            }

            .confirm {
                margin-left: 20px;
                background: #409eff;
                color: rgba(255, 255, 255, 0.9);
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/tabs/my.vue